import React from 'react';
import { Stack, Typography, Card, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatisticsContainer = styled(Stack)(({ theme }) => ({
  gap: '16px'
}));

// Section title removed per design request (compact footer stats)

const StatisticsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '0px'
}));

const StatCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#ffffff',
  padding: '18px',
  borderRadius: 10,
  boxShadow: '0 6px 18px rgba(12, 40, 80, 0.06)',
  flex: 1,
  textAlign: 'center',
  minHeight: '96px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  transition: 'transform 0.12s ease, box-shadow 0.12s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 30px rgba(12, 40, 80, 0.09)'
  }
}));

const StatLabel = styled(Typography)(({ theme, color }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  fontWeight: 600,
  color: color || '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.6px'
}));

const StatValue = styled(Typography)(({ theme, color }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '20px',
  fontWeight: 700,
  color: color || '#0b91d6'
}));

const StatMeta = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  color: '#9aa0a6'
}));

const MeetingStatisticsSection = ({ meetingDetails }) => {
  const getStatColor = (status) => {
    switch (status) {
      case 'Total Meeting':
        return '#0b91d6';
      case 'Open Meeting':
        return '#34a853';
      case 'Closed':
        return '#ef232a';
      case 'Follow up':
        return '#fbbc05';
      case 'Reassigned':
        return '#0044c9';
      case 'Not Attendant':
        return 'rgba(18, 29, 19, 0.75)';
      case 'Person Not Available':
        return '#7b95ff';
      case 'Not Interested':
        return '#a0a0aa';
      default:
        return '#0b91d6';
    }
  };

  return (
    <StatisticsContainer>
      <StatisticsRow>
        {meetingDetails.map((stat, index) => (
          <StatCard key={index}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: stat.color || '#0b91d6' }} />
              <StatLabel color={stat.color}>{stat.status}</StatLabel>
            </Box>
            <StatValue color={stat.color}>{stat.count}</StatValue>
            <StatMeta>{/* optional small meta or percentage could go here */}</StatMeta>
          </StatCard>
        ))}
      </StatisticsRow>
    </StatisticsContainer>
  );
};

export default MeetingStatisticsSection;